import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib";
import FormItemDropdown from "../../../../components/form-dropdown/FormItemDropdown";
import { globalStore } from "../../../../stores/stores";
import { getManageUniversities } from "../../../user-info/account/services";
import UniversityTreeSelect from "../../../../components/university-tree-select/UniversityTreeSelect";
import "./filter-group.scss";

type FormFilterProps = {
  check?: boolean;
  filterData: any;
  dataOptions?: any;
  form: FormInstance;
  showFilter?: boolean;
  onFinish?: () => void;
  clearFilter: () => void;
  handleCloseFilter: () => void;
  setIsDaiHoc: (value: boolean) => void;
  setFilterData: (dateString: string[], planCreationDate: string) => void;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  form,
  check,
  showFilter,
  filterData,
  dataOptions,
  onFinish,
  clearFilter,
  setIsDaiHoc,
  setFilterData,
  handleCloseFilter,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const [dataUniversity, setDataUniversity] = useState<any>();
  const { reload } = globalStore();

  const listStatus = [
    {
      id: 1,
      name: t("khóa", "Khóa"),
    },
    {
      id: 2,
      name: t("mở khóa", "Mở khóa"),
    },
  ];

  useEffect(() => {
    const getListEnterprise = async () => {
      const res = await getManageUniversities({});
      try {
        if (res.status === 200) {
          setDataUniversity(res.data.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    getListEnterprise();
  }, [reload]);

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            {!check ? (
              <Col
                xl={{ span: 5 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Trường đại học", "Trường đại học")}</Typography.Title>
                <Form.Item name="universityId">
                  <UniversityTreeSelect
                    data={dataUniversity}
                    onChange={(value) => {
                      setIsDaiHoc(value?.isDaiHoc);
                      setFilterData(value?.uuid, "universityId");
                    }}
                  />
                </Form.Item>
              </Col>
            ) : null}
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Trạng thái", "Trạng thái")}</Typography.Title>
              <Form.Item name="status">
                <FormItemDropdown
                  placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                  onChange={(option) => setFilterData(option, "status")}
                  options={listStatus}
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Ngày tạo", "Ngày tạo")}</Typography.Title>
              <Form.Item name="approvedDate">
                <RangePicker
                  placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                  format="YYYY-MM-DD"
                  value={filterData.approvedDate}
                  onChange={(_value, dateString: any) =>
                    setFilterData(dateString, "approvedDate")
                  }
                />
              </Form.Item>
            </Col>

            <Col
              xl={{ span: 3 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  onClick={() => form.submit()}
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
